import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import NewWithdrawTemplateButton from './NewWithdrawTemplateButton';
import WithdrawTemplateRow from './WithdrawTemplateRow';
import Pagination from '../../components/Pagination/Pagination';
import WithdrawTemplateModal from './WithdrawTemplateModal/WithdrawTemplateModal';
import Toast from '../../components/Toast/Toast';
import { getWithdrawTemplates, deleteWithdrawTemplate } from '../../services/WithdrawTemplatesService';
import { doWithdraw } from '../../services/ExchangeService';

function WithdrawTemplates() {

    useEffect(() => {
        if (window.location.href.indexOf('localhost') !== -1)
            setNotification({ type: 'info', text: 'These features only work in production.' });
    }, [])

    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    const history = useHistory();

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        })
    }, [history])

    const [withdrawTemplates, setWithdrawTemplates] = useState([]);

    const [notification, setNotification] = useState([]);

    const [count, setCount] = useState(0);

    const [editWithdrawTemplate, setEditWithdrawTemplate] = useState({});

    const [page, setPage] = useState(getPage());

    useEffect(() => {
        getWithdrawTemplates('', page || 1)
            .then(result => {
                setWithdrawTemplates(result.rows ? result.rows : []);
                setCount(result.count);
                setEditWithdrawTemplate(result.rows && result.rows.length > 0 ? result.rows[0] : {});
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })

    }, [page])

    function onEditClick(event) {
        const id = event.target.id.replace('edit', '');
        // eslint-disable-next-line
        const template = withdrawTemplates.find(o => o.id == id);
        setEditWithdrawTemplate({...template});
    }

    function onDeleteClick(event) {
        const id = event.target.id.replace('delete', '');
        deleteWithdrawTemplate(id)
            .then(result => history.go(0))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })
    }

    function onRunClick(event) {
        const id = event.target.id.replace('run', '');
        doWithdraw(id)
            .then(result => setNotification({ type: 'success', text: `Withdrawal #${result.id} successful!` }))
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            })
    }

    function onWithdrawTemplateSubmit(template) {
        history.go(0);
    }

    return (
        <React.Fragment>
            <PrivatePageLayout>
                <PageHeader
                    eyebrow="Trading"
                    title="Withdraw templates"
                    subtitle="Save and reuse withdrawal configurations for your exchange account."
                    actions={<NewWithdrawTemplateButton />}
                />
                <PageTableCard>
                    <div className="table-wrapper table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="border-gray-200">Coin</th>
                                    <th className="border-gray-200">Name</th>
                                    <th className="border-gray-200">Amount</th>
                                    <th className="border-gray-200">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {withdrawTemplates && withdrawTemplates.length
                                    ? withdrawTemplates.map((ot) => (
                                        <WithdrawTemplateRow
                                            key={ot.id}
                                            data={ot}
                                            onEditClick={onEditClick}
                                            onDeleteClick={onDeleteClick}
                                            onRunClick={onRunClick}
                                        />
                                    ))
                                    : null}
                            </tbody>
                        </table>
                    </div>
                    <Pagination count={count} />
                </PageTableCard>
            </PrivatePageLayout>
            <WithdrawTemplateModal data={editWithdrawTemplate} onSubmit={onWithdrawTemplateSubmit} />
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default WithdrawTemplates;
